import { Component } from '@angular/core';
import { environment } from '@src/environments/environment';

@Component({
  selector: 'app-home',
  imports: [],
  templateUrl: './home.html',
  styleUrl: './home.scss',
})
export class Home {
  title = 'mec-tracking-ui';
  configuration = `Deploy region: ${environment.region}, Environment: ${environment.type}.`;
}
